import { Contract } from '../../../../interfaces/Contract';
import { ContractDto } from '../../../../interfaces/dtos/ContractDto';

export default function transformContracts(dtos: ContractDto[]): Contract[] {
  const contracts: Contract[] = [];
  dtos?.forEach((dto) => {
    contracts.push({
      productCode: dto.productCode,
      systemCode: dto.systemCode,
      number: dto.number,
      description: dto.description,
      systemExclusionMessage: dto.systemExclusionMessage,
    });
  });
  return contracts;
}
